export default "__VITE_ASSET__Bi7p6ktc__";